var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "overlay-modal",
    {
      ref: "overlayModal",
      attrs: { width: "65%" },
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function() {
            return [
              _c("div", { staticClass: "d-md-flex justify-content-between" }, [
                _c("div", [
                  _c(
                    "h6",
                    { staticClass: "text-uppercase text-primary mb-0" },
                    [_vm._v(_vm._s(_vm.category))]
                  ),
                  _vm._v(" "),
                  _c("h4", { staticClass: "mb-0 cursive" }, [
                    _vm._v(_vm._s(_vm.name))
                  ])
                ]),
                _vm._v(" "),
                !_vm.isTrasferimento
                  ? _c("div", [
                      !_vm.isSelected
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "mt-2 mt-md-0 btn btn-primary nowrap",
                              attrs: { disabled: !_vm.modified },
                              on: { click: _vm.onConfirm }
                            },
                            [
                              _vm._v(
                                "\n                    Aggiungi ad itinerario\n                "
                              )
                            ]
                          )
                        : _c(
                            "button",
                            {
                              staticClass:
                                "mt-2 mt-md-0 btn btn-primary nowrap",
                              attrs: { disabled: !_vm.modified },
                              on: { click: _vm.onConfirm }
                            },
                            [
                              _vm._v(
                                "\n                    Conferma modifiche\n                "
                              )
                            ]
                          )
                    ])
                  : _c(
                      "div",
                      { staticClass: "d-flex justify-content-between" },
                      [
                        _vm.showAggiungiAndata
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "mt-2 mt-md-0 btn btn-primary nowrap mx-1",
                                attrs: {
                                  disabled: _vm.value.isTrasferimentoFisso
                                },
                                on: { click: _vm.onAggiungiAndata }
                              },
                              [_vm._v("+ andata")]
                            )
                          : _c(
                              "button",
                              {
                                staticClass:
                                  "mt-2 mt-md-0 btn btn-secondary mx-1",
                                attrs: {
                                  disabled: _vm.value.isTrasferimentoFisso
                                },
                                on: { click: _vm.onRemoveAndata }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("../../../../assets/images/svg/white/icone_cestino.svg"),
                                    width: "16px"
                                  }
                                }),
                                _vm._v(
                                  "\n                    andata\n                "
                                )
                              ]
                            ),
                        _vm._v(" "),
                        _vm.showAggiungiRitorno
                          ? _c(
                              "button",
                              {
                                staticClass:
                                  "mt-2 mt-md-0 btn btn-primary nowrap mx-1",
                                attrs: {
                                  disabled: _vm.value.isTrasferimentoFisso
                                },
                                on: { click: _vm.onAggiungiRitorno }
                              },
                              [_vm._v("+ ritorno")]
                            )
                          : _c(
                              "button",
                              {
                                staticClass:
                                  "mt-2 mt-md-0 btn btn-secondary mx-1",
                                attrs: {
                                  disabled: _vm.value.isTrasferimentoFisso
                                },
                                on: { click: _vm.onRemoveRitorno }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("../../../../assets/images/svg/white/icone_cestino.svg"),
                                    width: "16px"
                                  }
                                }),
                                _vm._v(
                                  "\n                    ritorno\n                "
                                )
                              ]
                            )
                      ]
                    )
              ])
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      [
        _c("div", { staticClass: "modal-service-detail" }, [
          _c(
            "div",
            [
              _vm.images.length > 0
                ? _c("big-carousel", {
                    ref: "carouselRef",
                    staticClass: "mb-3",
                    attrs: { images: _vm.images }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "tabs",
                { staticClass: "mb-3" },
                [
                  !_vm.isTrasferimento && !_vm.value.isObbligatorio
                    ? _c(
                        "tab",
                        { attrs: { title: "Seleziona le date" } },
                        _vm._l(_vm.groups, function(item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "mb-3" },
                            [
                              _c("h3", [
                                _vm._v(_vm._s("Camera " + (index + 1)))
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "d-flex mb-2" }, [
                                _c("img", {
                                  staticClass: "mr-2",
                                  attrs: {
                                    src: require("../../../../assets/images/svg/black/icone_passeggeri.svg"),
                                    height: "18px"
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "d-block" }, [
                                  _vm._v(_vm._s(_vm.cameraTextFromIndex(index)))
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "row" },
                                _vm._l(_vm.days, function(item, index2) {
                                  return _c(
                                    "div",
                                    {
                                      key: index2,
                                      staticClass: "col-6 col-md-3"
                                    },
                                    [
                                      _c("div", { staticClass: "my-2" }, [
                                        _c(
                                          "button",
                                          {
                                            class: _vm.classes(index, item.day),
                                            on: {
                                              click: function($event) {
                                                return _vm.onChange(
                                                  index,
                                                  item.day
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.longDateFormatter(
                                                    item.day
                                                  )
                                                ) +
                                                "\n                                        "
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                                }),
                                0
                              )
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "tab",
                    {
                      attrs: { title: "Descrizione" },
                      on: { click: _vm.onSelectTabDescrizione }
                    },
                    [
                      _c("p", {
                        staticClass: "text-justify",
                        staticStyle: { "white-space": "pre-line" },
                        domProps: { innerHTML: _vm._s(_vm.description) }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("tab", { attrs: { title: "Note" } }, [
                    !_vm.isMobile
                      ? _c("table", { staticClass: "table table-striped" }, [
                          _c(
                            "tbody",
                            _vm._l(_vm.notes, function(item, index) {
                              return _c("tr", { key: index }, [
                                _c("td", { staticStyle: { width: "30%" } }, [
                                  _c("b", [_vm._v(_vm._s(item.title))])
                                ]),
                                _vm._v(" "),
                                _c("td", { staticStyle: { width: "70%" } }, [
                                  _c("p", {
                                    staticClass: "m-0",
                                    domProps: { innerHTML: _vm._s(item.text) }
                                  })
                                ])
                              ])
                            }),
                            0
                          )
                        ])
                      : _c(
                          "div",
                          _vm._l(_vm.notes, function(item, index) {
                            return _c("div", { key: index }, [
                              _c("b", [_vm._v(_vm._s(item.title))]),
                              _vm._v(" "),
                              _c("p", {
                                staticClass: "mb-3 border-top pt-1",
                                domProps: { innerHTML: _vm._s(item.text) }
                              })
                            ])
                          }),
                          0
                        )
                  ])
                ],
                1
              )
            ],
            1
          )
        ])
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e439170", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e439170","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/common/modals/ModalServiceDetail.vue
// module id = null
// module chunks = 